import * as React from 'react';

import { cn } from '../../lib/utils';

type InputProps = React.ComponentProps<'input'> & {
  /**
   * The value is a machine identifier (slug, alias, license key, image tag):
   * IBM Plex Mono, with spellcheck, autocorrect and autocapitalize off so the
   * browser never "fixes" it. A caller's explicit prop still wins
   * (DESIGN_SYSTEM.md §3 Faces).
   */
  mono?: boolean;
};

const MONO_DEFAULTS = { spellCheck: false, autoCorrect: 'off', autoCapitalize: 'off' } as React.InputHTMLAttributes<HTMLInputElement>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, mono = false, ...props }, ref) => {
    return (
      <input
        type={type}
        {...(mono ? MONO_DEFAULTS : {})}
        {...props}
        className={cn(
          'flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 aria-[invalid=true]:border-destructive-border aria-[invalid=true]:ring-2 aria-[invalid=true]:ring-destructive/20',
          mono && 'font-mono',
          className
        )}
        ref={ref}
      />
    );
  }
);
Input.displayName = 'Input';

export { Input };
